import { Box } from "@mui/material";
import {
  GridToolbarContainer,
  type GridToolbarProps,
  type ToolbarPropsOverrides,
} from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { common, input } from "../../i18n";
import { CustomGridToolbarQuickFilter } from "./CustomGridToolbarQuickFilter";

declare module "@mui/x-data-grid" {
  interface ToolbarPropsOverrides {
    button?: React.ReactElement;
  }
}

type CustomToolbarProps = GridToolbarProps &
  ToolbarPropsOverrides & {
    button?: JSX.Element;
  };

export const CustomToolbar: React.FC<CustomToolbarProps> = ({ button }) => {
  const { t: _t } = useTranslation([common, input], {
    nsMode: "fallback",
  });

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      gap={"40px"}
      marginBottom={"40px"}
    >
      <Box
        display={"flex"}
        flexDirection={{ xs: "column-reverse", sm: "row" }}
        justifyContent={"space-between"}
        alignItems={"self-end"}
        gap={4}
      >
        <Box
          display={"flex"}
          columnGap={"12px"}
          flex={1}
          alignItems={"self-end"}
          alignContent={"stretch"}
          width={{ xs: "100%", sm: "auto" }}
        >
          <CustomGridToolbarQuickFilter />
        </Box>

        <GridToolbarContainer
          sx={{
            padding: 0,
            width: { xs: "100%", sm: "auto" },
          }}
        >
          {button}
        </GridToolbarContainer>
      </Box>
    </Box>
  );
};
